import { EditTreatmentOverviewFormData } from '../types/notes/EditTreatmentOverviewFormData';
import {
  BaseTreatmentAttribute,
  TreatmentAttributeEnum,
  TreatmentAttributeLevelEnum,
} from '../types/treatmentAttributes/treatmentAttributes';

export const createTreatmentEpisodeAttributesPayload = (
  formData: EditTreatmentOverviewFormData,
) => {
  return {
    discussionOfWeight: formData.discussionOfWeight?.explanation
      ? {
          code: formData.discussionOfWeight.code,
          explanation: formData.discussionOfWeight.explanation,
        }
      : undefined,
    form: formData.form?.explanation
      ? {
          // code may be cleared in a special case where modality is changed from one with a form to one without
          code: formData.form.code ?? null,
          explanation: formData.form.explanation,
        }
      : undefined,
    level: formData.level?.explanation
      ? {
          explanation: formData.level.explanation,
          levelId: formData.level.id,
        }
      : undefined,
    modality: formData.modality?.explanation
      ? {
          code: formData.modality.code,
          explanation: formData.modality.explanation,
        }
      : undefined,
    phaseStage: formData.phaseStage?.explanation
      ? {
          code: formData.phaseStage.code,
          explanation: formData.phaseStage.explanation,
        }
      : undefined,
    saferStage: formData.saferStage?.explanation
      ? {
          code: formData.saferStage.code,
          explanation: formData.saferStage.explanation,
        }
      : undefined,
    startDate: new Date().toISOString(),
  };
};

// Attribute lists come back ordered date_start DESC with no date_end filter, so the newest row
// is not necessarily the current one - a closed row can sort ahead of the open one.
export const getOpenTreatmentAttribute = <T extends BaseTreatmentAttribute>(
  attributes?: T[],
): T | undefined => attributes?.find((attribute) => attribute.endDate == null);

export const getTreatmentAttributeEnum = (
  attribute?: BaseTreatmentAttribute,
): TreatmentAttributeEnum | TreatmentAttributeLevelEnum | null => {
  if (!attribute) {
    return null;
  }

  let attributeEnum: unknown;
  if ('modality' in attribute) {
    attributeEnum = attribute.modality;
  } else if ('discussionOfWeight' in attribute) {
    attributeEnum = attribute.discussionOfWeight;
  } else if ('saferStage' in attribute) {
    attributeEnum = attribute.saferStage;
  } else if ('refeedingRisk' in attribute) {
    attributeEnum = attribute.refeedingRisk;
  } else if ('level' in attribute) {
    attributeEnum = attribute.level;
  } else if ('form' in attribute) {
    attributeEnum = attribute.form;
  } else if ('phaseStage' in attribute) {
    attributeEnum = attribute.phaseStage;
  } else if ('medicalStability' in attribute) {
    attributeEnum = attribute.medicalStability;
  } else if ('psychiatricStability' in attribute) {
    attributeEnum = attribute.psychiatricStability;
  }

  return attributeEnum as TreatmentAttributeEnum | TreatmentAttributeLevelEnum;
};
